import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./CarRental.css";

function AvisLogo() {
  return (
    <svg viewBox="0 0 80 40" width="100%" height="100%">
      <rect width="80" height="40" rx="4" fill="#d32f2f" />
      <text x="40" y="27" textAnchor="middle" fill="#fff" fontSize="20" fontWeight="700" fontFamily="Arial, sans-serif">AVIS</text>
    </svg>
  );
}

function HertzLogo() {
  return (
    <svg viewBox="0 0 80 40" width="100%" height="100%">
      <rect width="80" height="40" rx="4" fill="#1a1a1a" />
      <text x="40" y="27" textAnchor="middle" fill="#ffd700" fontSize="18" fontWeight="700" fontFamily="Arial, sans-serif">HERTZ</text>
    </svg>
  );
}

function NationalLogo() {
  return (
    <svg viewBox="0 0 80 40" width="100%" height="100%">
      <rect width="80" height="40" rx="4" fill="#006847" />
      <text x="40" y="26" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="700" fontFamily="Arial, sans-serif">NATIONAL</text>
    </svg>
  );
}

const COMPANIES = [
  {
    id: "avis",
    name: "Avis",
    tier: "Preferred Plus",
    discount: "30%",
    perks: ["Skip the counter", "Free weekend rental", "Class upgrade", "Priority return"],
    car: { model: "Toyota Corolla", price: 38, wasPrice: 54 },
    color: "#d32f2f",
    Logo: AvisLogo,
    url: "https://www.avis.com",
  },
  {
    id: "hertz",
    name: "Hertz",
    tier: "Five Star",
    discount: "25%",
    perks: ["Priority pickup", "Extra return hours", "Bonus points", "Free additional driver"],
    car: { model: "VW Golf", price: 42, wasPrice: 56 },
    color: "#ffd700",
    Logo: HertzLogo,
    url: "https://www.hertz.com",
  },
  {
    id: "national",
    name: "National",
    tier: "Emerald Executive",
    discount: "25%",
    perks: ["Emerald Aisle access", "Choose any car in aisle", "No 2nd driver fee", "Guaranteed upgrade"],
    car: { model: "Nissan Qashqai", price: 45, wasPrice: 60 },
    color: "#006847",
    Logo: NationalLogo,
    url: "https://www.nationalcar.com",
  },
];

export default function CarRental() {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="car-rental">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="cr-hero">
        <h1 className="cr-title">Drive Like an Executive</h1>
        <p className="cr-subtitle">Instant elite status. Skip the line, get upgraded, save up to 30%.</p>
      </section>

      <div className="cr-highlights">
        <div className="cr-highlight">
          <span className="cr-hl-value">30%</span>
          <span className="cr-hl-label">Max discount</span>
        </div>
        <div className="cr-highlight">
          <span className="cr-hl-value">3</span>
          <span className="cr-hl-label">Partners</span>
        </div>
        <div className="cr-highlight">
          <span className="cr-hl-value">Elite</span>
          <span className="cr-hl-label">Status</span>
        </div>
      </div>

      {/* Company cards */}
      <section className="cr-companies">
        {COMPANIES.map((c) => {
          const isOpen = expandedId === c.id;
          return (
            <div key={c.id} className={`cr-company ${isOpen ? "expanded" : ""}`}>
              <button
                className="cr-company-header"
                onClick={() => setExpandedId(isOpen ? null : c.id)}
                type="button"
              >
                <span className="cr-company-logo"><c.Logo /></span>
                <div className="cr-company-info">
                  <span className="cr-company-name">{c.name}</span>
                  <span className="cr-company-tier">{c.tier}</span>
                </div>
                <div className="cr-company-right">
                  <span className="cr-company-discount">{c.discount} off</span>
                  <span className={`cr-company-chevron ${isOpen ? "open" : ""}`}>›</span>
                </div>
              </button>

              {isOpen && (
                <div className="cr-company-body">
                  <div className="cr-perks">
                    {c.perks.map((p, i) => (
                      <div key={i} className="cr-perk">
                        <span className="cr-perk-check">✓</span>
                        <span>{p}</span>
                      </div>
                    ))}
                  </div>

                  <div className="cr-car-offer">
                    <div className="cr-car-info">
                      <span className="cr-car-model">{c.car.model}</span>
                      <span className="cr-car-pricing">
                        <strong>${c.car.price}</strong>/day
                        <span className="cr-car-was">${c.car.wasPrice}</span>
                      </span>
                    </div>
                    <a className="cr-book-btn" href={c.url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                      Book
                    </a>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </section>

      <div className="cr-tip">
        Diamond members save an average of <strong>$340/year</strong> on car rentals
      </div>

      <div className="cr-close-wrap">
        <Link to="/benefits" className="cr-close">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
